export const STRINGS = {
  laundryMenuHeader: {
    SE: 'Tvätt',
    EN: 'Laundry'
  },
  mySettingsHeader: {
    SE: 'Inställingar',
    EN: 'Settings'
  },
  passed: {
    SE: 'Passerad',
    EN: 'Passed'
  },
  wrongCodeHeader: {
    SE: 'Fel kod',
    EN: 'Wrong code'
  },
  wrongCodeText: {
    SE:
      'Du angav fel föreningskod, kontakta din förening om du inte har fått någon kod.',
    EN:
      'You entered the wrong compound code, contact your landlord if you do not have a code.'
  },
  compoundCode: {
    SE: 'Föreningskod',
    EN: 'Compound code'
  },
  createAccount: {
    SE: 'Skapa konto',
    EN: 'Create account'
  },
  apartmentExistsHeader: {
    SE: 'Lägenhetsnummer upptaget',
    EN: 'Apartment number taken'
  },
  apartmentExistsText: {
    SE:
      'Det finns redan ett konto med det valda lägenhetsnumret i er förening.',
    EN:
      'There already exists an account with the chosen apartmentnumber in your compund.'
  },
  compundCodeHelpHeader: {
    SE: 'Föreningskod',
    EN: 'Compound code'
  },
  compundCodeHelpText: {
    SE:
      'I detta fältet anger du din förenings privata kod för att skapa ett konto. Koden finns på manualen som du får av din förening. Kontakta din förening om du inte har fått någon kod.',
    EN:
      'In this field you enter your compounds private code for creating accounts. The code can be found on the manual that your compound have supplied you with. Please contact your landlord if you have not received a code.'
  },
  send: {
    SE: 'Skicka',
    EN: 'Send'
  },
  message: {
    SE: 'Meddelande',
    EN: 'Message'
  },
  contact: {
    SE: 'Kontakt',
    EN: 'Contact'
  },
  contactUs: {
    SE: 'Kontakta oss',
    EN: 'Contact us'
  },
  emailSentHeader: {
    SE: 'Email skickat',
    EN: 'Email sent'
  },
  emailSentText: {
    SE:
      'Ett email har skickats till dig med en länk för att återställa ditt lösenord.',
    EN: 'An email has been sent to you to reset your password.'
  },
  backToLogin: {
    SE: 'Tillbaka till inloggning',
    EN: 'Back to login'
  },
  sendResetEmail: {
    SE: 'Skicka återställningsmail',
    EN: 'Send reset email'
  },
  cantFindEmailHeader: {
    SE: 'Email existerar ej',
    EN: 'Email does not exist'
  },
  forgotPassword: {
    SE: 'Glömt lösenord',
    EN: 'Forgot password'
  },
  cantFindEmailText: {
    SE:
      'Emailen du angav existerar ej, var vänlig se om du skrev in rätt email.',
    EN:
      'The email you specified does not exist, please check if you enter the correct one.'
  },
  subject: {
    SE: 'Ämne',
    EN: 'Subject'
  },
  contactText: {
    SE:
      'Har du någon fundering kring HomePal eller är intresserad av att bli kund. Tveka då inte på att skicka ett meddelande till oss. Vi svarar alltid inom 24 timmar.',
    EN:
      'If you are wondering anything regarding HomePal or if you are interested in becoming a customer, then please do not hesitate do contact us. We will get back to you within 24 hours.'
  },
  homePalIs: {
    SE:
      'HomePal är en platform för din hyres- eller bostadsrättsförening. För närvarande tillahandahåller vi ett tvättbokningssystem där man bokar tvättid via vår hemsida eller via vår mobilapplikation.',
    EN:
      'HomePal is a platform that provides a service for booking laundrytimes. We provide both a webapplication and a mobileapplication.'
  },
  whatIsIncluded: {
    SE: 'Vad innebär det att bli en HomePal?',
    EN: 'What does it mean to become a HomePal?'
  },
  twoMonthsFree: {
    SE: 'Ni debiteras kvartalsvis efter vår prismodell',
    EN: 'You will be charged quarterly according to our pricing model'
  },
  noBindingTime: {
    SE:
      'Ni kan närsomhelst avsluta er prenumeration, det är ingen bindningstid',
    EN: 'You can at any time end your subscription, there is no binding time'
  },
  compoundSuccesfullyUpdated: {
    SE: 'Din förening har uppdaterats',
    EN: 'Your compound has been updated'
  },
  compoundName: {
    SE: 'Föreningsnamn',
    EN: 'Compound name'
  },
  laundryBooking: {
    SE: 'Digitalt tvättbokningssystem',
    EN: 'A digital laundry booking system'
  },
  selectAdmins1: {
    SE: 'Ni väljer själva vilka och hur många som som ska kunna ',
    EN: 'Select yourselves who and how many that are able to '
  },
  selectAdmins2: {
    SE: 'administrera systemet',
    EN: 'administrate the system'
  },
  sysAdmin: {
    SE: 'Systemadministrering',
    EN: 'System administration'
  },
  infiniteAdmins: {
    SE: 'Välj själv antalet administratörer',
    EN: 'Choose the number of administrators yourself'
  },
  contactInformation: {
    SE: 'Kontaktuppgifter',
    EN: 'Contact information'
  },
  communityInformation: {
    SE: 'Föreningsuppgifter',
    EN: 'Compound information'
  },
  cantFindCity: {
    SE: 'Jag hittar inte min stad',
    EN: 'I can not find my city'
  },
  enterNowOrLater: {
    SE:
      'Vill du fylla i din förenings tvättregler nu eller spara det till senare?',
    EN:
      'Would you like to enter your laundry rules right now or would you like to wait until you have finnished your signup?'
  },
  summary: {
    SE: 'Sammanfattning',
    EN: 'Summary'
  },
  iWantToDoItNow: {
    SE: 'Jag vill fylla i min förenings tvättregler nu.',
    EN: "I want to add my compound's laundry settings now."
  },
  iWantToDoItLater: {
    SE: 'Jag ställer in min förenings tvättregler senare i inloggat läge.',
    EN: 'I will set my laundry rules later when I am logged in.'
  },
  accessToLaundryBooking1: {
    SE: 'Hela föreningen får tillgång till det ',
    EN: 'The whole compound gets access to the '
  },
  accessToLaundryBooking2: {
    SE: 'digitala tvättbokningssystemet',
    EN: 'digital laundry bookingsystem'
  },
  aboutLaundrbooking: {
    SE:
      'Vårat tvättbokningssystem är utforat för att vem som helst ska kunna använda det, både äldre som yngre.',
    EN:
      'The laundry booking system is designed such that anybody can use it. Booking laundry times should be easy!'
  },
  emailExistsHeader: {
    SE: 'Emailadressen finns redan',
    EN: 'The email address already exists'
  },
  emailExistsText: {
    SE:
      'Emailadressen du angav används redan, vänligen mata in en annan email.',
    EN:
      'The email address you specified already exists, please enter a new one and try again.'
  },
  appartmentExistsHeader: {
    SE: 'Lägenhetsnumret finns redan i din förening',
    EN: 'The appartment number already exists in your association'
  },
  appartmentNumber: {
    SE: 'Lägenhetsnummer',
    EN: 'Apartment number'
  },
  appartmentExistsText: {
    SE:
      'Lägenhetsnumret du angav används redan, vänligen kontakta din förening om detta inte stämmer.',
    EN:
      'The appartment number you specified already exists, please contact your association if this is not true.'
  },
  book: {
    SE: 'Boka',
    EN: 'Book time'
  },
  about: {
    SE: 'Om',
    EN: 'About'
  },
  adminUsersHeader: {
    SE: 'Administrera användare',
    EN: 'Administrate users'
  },
  aboutAdminUsers: {
    SE:
      'I systemet har du alltid full koll på dina användare och kan enkelt lägga till eller ändra en användares uppgifter.',
    EN:
      'The administrator account will always have full control over the users and can when ever he or she want add or delete a users information.'
  },
  movingOut: {
    SE: 'Utflytt',
    EN: 'Moving out'
  },
  aboutMovingOut: {
    SE:
      'När någon flyttar ut ur en lägenhet kan du enkelt via enbart ett knapptryck återställa en användare så att dess email nollställs och lägenhetens lösenord sätts till lägenhetsnumret.',
    EN:
      'When someone moves out of their apartment you can easily reset that persons accout with a single click. When the account is reseted the email is zeroed out and the password is set to the apartmentnumber'
  },
  adminSettingsHeader: {
    SE: 'Administrera inställningar',
    EN: 'Administrate settings'
  },
  aboutAdminSettings: {
    SE: 'Det är möjligt att konfigurera systemet enligt era tvättvanor.',
    EN: 'It is possible to adjust the system for your needs.'
  },
  aboutLaundryMachine: {
    SE:
      'Vill ni att man ska kunna boka enskilda tvättmaskiner i tvättstugan går det att ställa in så att man bokar en eller flera i taget.',
    EN:
      'If you desire to be able to book single washingmachines in the house then you can add how many washingmachine to the bookingtable as you like.'
  },
  aboutWashHouse: {
    SE:
      'Vill ni att man ska kunna boka en hel tvättstuga åtgången kan ni ställa in det. Har ni fler än en tvättstuga som ni vill ska vara bokningsbar kan ni ställa in så att man kan boka fler än en tvättstuga.',
    EN:
      'If you want to book an entire laundry room you can set it up. If you have more than one laundry room you want to be bookable, you can set up so that you can book more than one laundry room.'
  },
  home: {
    SE: 'Hem',
    EN: 'Home'
  },
  aboutUs: {
    SE: 'Om oss',
    EN: 'About us'
  },
  us: {
    SE: 'Oss',
    EN: 'Us'
  },
  aboutSystem: {
    SE: 'Om systemet',
    EN: 'About the system'
  },
  becomeCustomer: {
    SE: 'Bli kund',
    EN: 'Become customer'
  },
  oldPassword: {
    SE: 'Tidigare lösenord',
    EN: 'Previous password'
  },
  general: {
    SE: 'Allmänt',
    EN: 'General'
  },
  changeEmail: {
    SE: 'Byt email',
    EN: 'Change email'
  },
  firstName: {
    SE: 'Förnamn',
    EN: 'First name'
  },
  phoneNumber: {
    SE: 'Telefonnummer',
    EN: 'Phone number'
  },
  postalNumber: {
    SE: 'Postnummer',
    EN: 'Zip code'
  },
  organizationNumber: {
    SE: 'Organisationsnummer',
    EN: 'Organization number'
  },
  emailsDontMatchHeader: {
    SE: 'Emailadresserna matchar inte',
    EN: 'Emails are not matched'
  },
  emailsDontMatchText: {
    SE: 'Emailadresserna du angav matchar inte varandra, vänligen försök igen.',
    EN: "The emails you enter don't match eachother"
  },
  emailNotValidHeader: {
    SE: 'Ej giltlig emailadress',
    EN: 'Email address not valid'
  },
  emailNotValidText: {
    SE: 'Emailen du angav är inte giltig, skriv in en giltig email.',
    EN: 'The email address you entered is not valid, please enter a new one.'
  },
  security: {
    SE: 'Säkerhet',
    EN: 'Security'
  },
  changePassword: {
    SE: 'Byt lösenord',
    EN: 'Change password'
  },
  changedPasswordHeader: {
    SE: 'Lösenord ändrat',
    EN: 'Changed password'
  },
  changedPasswordText: {
    SE:
      'Du har nu återställt ditt lösenord, tryck på "till login" för att logga in med ditt nya lösenord.',
    EN:
      'You have now changed your password, press "to sign in" to login with your new password.'
  },
  updateEmail: {
    SE: 'Uppdatera email',
    EN: 'Update email'
  },
  updatePassword: {
    SE: 'Uppdatera lösenord',
    EN: 'Update password'
  },
  newEmail: {
    SE: 'Ny email',
    EN: 'New email'
  },
  newPassword: {
    SE: 'Nytt lösenord',
    EN: 'New password'
  },
  repeatEmail: {
    SE: 'Upprepa email',
    EN: 'Repeat email'
  },
  aDigitalLaundryBookingSystem: {
    SE: 'Ett digitalt tvättbokningssystem för din förening',
    EN: 'A digital laundry booking system for your association'
  },
  getStartedWithYour60Days: {
    SE: 'Påbörja era 60 gratis dagar',
    EN: 'Start your 60 free days'
  },
  repeatPassword: {
    SE: 'Repetera lösenord',
    EN: 'Repeat password'
  },
  explainEmailChange: {
    SE:
      'Skriv in din nya emailadress och tryck spara så kommer dina Inställningar att uppdateras.',
    EN:
      'Type your new email and click save, your new email address will then be saved.'
  },
  explainPasswordChange: {
    SE:
      'Skriv in ditt nya lösenord och tryck spara så kommer dina Inställningar att uppdateras.',
    EN:
      'Type your new password and click save, your new password will then be saved.'
  },
  passwordUpdate: {
    SE: 'Ditt lösenord har uppdaterats',
    EN: 'Your password has been updated'
  },
  emailUpdate: {
    SE: 'Din email har uppdaterats',
    EN: 'Your email has been updated'
  },
  unbook: {
    SE: 'Avboka',
    EN: 'Unbook'
  },
  myBookings: {
    SE: 'Mina bokningar',
    EN: 'My bookings'
  },
  noBookings: {
    SE: 'Du har inte bokat någon tid',
    EN: 'There are no booked times'
  },
  citySelection: {
    SE: 'Välj Stad',
    EN: 'Select City'
  },
  writeCity: {
    SE: 'Skriv din stad',
    EN: 'Write your city'
  },
  communitySelection: {
    SE: 'Välj Förening',
    EN: 'Select Compound'
  },
  signIn: {
    SE: 'Logga in',
    EN: 'Sign in'
  },
  laundryBooked: {
    SE: 'Tvättiden har bokats',
    EN: 'The laundry time is booked'
  },
  search: {
    SE: 'Sök',
    EN: 'Search'
  },
  explainHowPasswordIsSet: {
    SE:
      'Lösenordet kommer att sättas till lähenhetsnummret. Användaren kan sedan själv ändra sitt lösenord.',
    EN:
      'The password will be set to the apartment number. The user may the change the password.'
  },
  calendarLanguage: {
    SE: 'sv-SV',
    EN: 'en-US'
  },
  error500Header: {
    SE: 'Något gick fel',
    EN: 'Something went wrong'
  },
  error500: {
    SE: 'Något gick fel, var god försök igen.',
    EN: 'Something went wrong, please try again.'
  },
  wrongCredentialsHeader: {
    SE: 'Fel inloggningsuppgifter',
    EN: 'Wrong credentials'
  },
  wrongCredentials: {
    SE: 'Ditt lösenord och email matchar ej, var god försök igen.',
    EN: "Your password and email doesn't match, please try again."
  },
  ok: {
    SE: 'Okej',
    EN: 'Okay'
  },
  error401Header: {
    SE: 'Sessionen har avslutats',
    EN: 'The session has expired'
  },
  error401: {
    SE:
      'Du har loggats ut pågrund av att din session har löpt ut, var god logga in igen.',
    EN:
      'You have been logged out since your session has expired, please log in again.'
  },
  yes: {
    SE: 'Ja',
    EN: 'Yes'
  },
  no: {
    SE: 'Nej',
    EN: 'No'
  },
  signOut: {
    SE: 'Logga ut',
    EN: 'Sign out'
  },
  signOutQuestion: {
    SE: 'Är du säker på att du vill logga ut?',
    EN: 'Are you sure you wish to sign out?'
  },
  users: {
    SE: 'Användare',
    EN: 'Users'
  },
  settings: {
    SE: 'Inställningar',
    EN: 'Settings'
  },
  apartmentNumber: {
    SE: 'Lägenhetsnummer',
    EN: 'Apartment Number'
  },
  changeApartmentNumber: {
    SE: 'Byt lägenhetsnummer',
    EN: 'Change apartment number'
  },
  newApartmentNumber: {
    SE: 'Nytt lägenhetsnummer',
    EN: 'New apartment number'
  },
  password: {
    SE: 'Lösenord',
    EN: 'Password'
  },
  admin: {
    SE: 'Administratör',
    EN: 'Administrator'
  },
  email: {
    SE: 'Email',
    EN: 'Email'
  },
  english: {
    SE: 'English',
    EN: 'English'
  },
  swedish: {
    SE: 'Svenska',
    EN: 'Svenska'
  },
  add: {
    SE: 'Lägg Till',
    EN: 'Add'
  },
  reset: {
    SE: 'Återställ',
    EN: 'Reset'
  },
  removeUserHeader: {
    SE: 'Ta bort lägenhet ',
    EN: 'Remove apartment '
  },
  bookTime: {
    SE: 'Boka tid',
    EN: 'Book time'
  },
  outOfOrderText: {
    SE: 'Vill du markera den här som ur funktion?',
    EN: 'Are you sure that you would like to mark this one as out of order?'
  },
  workingHeader: {
    SE: 'Fungerande',
    EN: 'Working'
  },
  workingText: {
    SE: 'Vill du markera den här som fungerade?',
    EN: 'Would you like to mark this one as functioning?'
  },
  removeUser: {
    SE: 'Är du säker på att du vill ta bort lägenhet ',
    EN: 'Are you sure you wish to remove apartment '
  },
  resetUserHeader: {
    SE: 'Återställ lägenhet ',
    EN: 'Reset apartment '
  },
  resetUser: {
    SE: 'Är du säker på att du vill återställa lägenhet ',
    EN: 'Are you sure you wish to reset apartment '
  },
  addNewUserHeader: {
    SE: 'Lägg till ny lägenhet',
    EN: 'Add new apartment'
  },
  cancel: {
    SE: 'Avbryt',
    EN: 'Cancel'
  },
  emailOptional: {
    SE: 'Email (Valfri)',
    EN: 'Email (Optional)'
  },
  numberOf: {
    SE: 'Antal',
    EN: 'Number of'
  },
  maxUsersHeader: {
    SE: 'Maximalt antal lägenheter',
    EN: 'Maximum apartments reached'
  },
  maxUsers1: {
    SE: 'Ditt paket tillåter endast ',
    EN: 'Your package only allows '
  },
  maxUsers2: {
    SE:
      ' lägenheter. Var god ta bort en lägenhet eller kontakta oss på info@bokatvatten.se.',
    EN:
      ' apartments. Please remove an apartment or contact us at info@bokatvatten.se.'
  },
  hasBeenRemoved: {
    SE: ' har tagits bort.',
    EN: ' has been removed.'
  },
  hasBeenReset: {
    SE: ' har återställts.',
    EN: ' has been reseted.'
  },
  hasBeenUpdated: {
    SE: ' har uppdaterats.',
    EN: ' has been updated.'
  },
  hasBeenAdded: {
    SE: ' har skapats.',
    EN: ' has been created.'
  },
  booking: {
    SE: 'bokning',
    EN: 'booking'
  },
  bookings: {
    SE: 'bokningar',
    EN: 'bookings'
  },
  error409DuplicateBookingHeader: {
    SE: 'Tiden är upptagen',
    EN: 'The time is busy'
  },
  error409DuplicateBooking: {
    SE: 'Tiden är redan bokad, var god välj en annan tid.',
    EN: 'The time is already booked, please choose a different time.'
  },
  maxBookingsHeader: {
    SE: 'Max bokningar uppnått',
    EN: 'Maximum bookings reached'
  },
  maxBookings1: {
    SE: 'Din förening tillåter endast ',
    EN: 'Your compound only allows '
  },
  maxBookings2: {
    SE: ' åt gången. Var god avboka en tid för att boka fler tider.',
    EN: ' at a time. Please unbook a time to make another booking.'
  },
  unbookTimeHeader: {
    SE: 'Avboka tvättid',
    EN: 'Unbook time'
  },
  emptyApartmentInputHeader: {
    SE: 'Lägenhetsnummer saknas',
    EN: 'Apartment number is missing'
  },
  emptyApartmentInput: {
    SE: 'Ett lägenhetsnummer krävs för att skapa en ny lägenhet.',
    EN: 'An apartment number is required to create a new apartment.'
  },
  duplicateApartmentInputHeader: {
    SE: 'Lägenhetsnummer finns redan',
    EN: 'The apartment number already exists'
  },
  duplicateApartmentInput: {
    SE:
      'Lägehnhetsnummer måste vara unika i föreningen, var god välj ett unikt lägenhetsnummer.',
    EN:
      'An apartment number must be unique, please choose an unique apartment number.'
  },
  communitySettings: {
    SE: 'Förenings inställningar',
    EN: 'Compound settings'
  },
  laundrySettings: {
    SE: 'Tvättinställningar',
    EN: 'Laundry settings'
  },
  laundryType: {
    SE: 'Tvättyp',
    EN: 'Laundry Type'
  },
  rangeSettings: {
    SE: 'Framtidsbokning',
    EN: 'Booking range'
  },
  noLimit: {
    SE: 'Ingen gräns',
    EN: 'No limit'
  },
  week: {
    SE: 'vecka',
    EN: 'week'
  },
  weeks: {
    SE: 'veckor',
    EN: 'weeks'
  },
  maxBookings: {
    SE: 'Max Bokningar',
    EN: 'Max Bookings'
  },
  washTime: {
    SE: 'tvättid',
    EN: 'laundry time'
  },
  washTimes: {
    SE: 'tvättider',
    EN: 'laundry times'
  },
  washTimesCap: {
    SE: 'Tvättider',
    EN: 'Laundry times'
  },
  save: {
    SE: 'Spara',
    EN: 'Save'
  },
  change: {
    SE: 'Ändra',
    EN: 'Change'
  },
  hourCap: {
    SE: 'Timme',
    EN: 'Hour'
  },
  minuteCap: {
    SE: 'Minut',
    EN: 'Minute'
  },
  newLaundryTime: {
    SE: 'Ny Tvättid',
    EN: 'New Laundry Time'
  },
  currentLaundryTimes: {
    SE: 'Nuvarande Tvättider',
    EN: 'Current Laundry Times'
  },
  laundryMachine: {
    SE: 'Tvättmaskin',
    EN: 'Laundry Machine'
  },
  washhouse: {
    SE: 'Tvättstuga',
    EN: 'Laundry room'
  },
  washhouses: {
    SE: 'Tvättstugor',
    EN: 'Laundry rooms'
  },
  myTimes: {
    SE: 'Mina tider',
    EN: 'My times'
  },
  yourLaundryMachine: {
    SE: 'Er tvättmaskin',
    EN: 'Your laundry machine'
  },
  yourLaundryMachines: {
    SE: 'Era tvättmaskiner',
    EN: 'Your laundry machines'
  },
  yourLaundryRoom: {
    SE: 'Er tvättstuga',
    EN: 'Your laundry room'
  },
  yourLaundryRooms: {
    SE: 'Era tvättstugor',
    EN: 'Your laundry rooms'
  },
  name: {
    SE: 'Namn',
    EN: 'Name'
  },
  giveName: {
    SE: 'Namnge',
    EN: 'Name'
  },
  unbookTime: {
    SE: 'Är du säker på att du vill avboka tvättstuga ',
    EN: 'Are you sure that you wish to unbook laundry '
  },
  laundryRules: {
    SE: 'Tvättregler',
    EN: 'Laundry Rules'
  },
  community: {
    SE: 'Förening',
    EN: 'Community'
  },
  newString: {
    SE: 'Ny',
    EN: 'New'
  },
  createNewLaundryHeader: {
    SE: 'Skapa en ny tvättstuga',
    EN: 'Create a new laundry room'
  },
  createNewLaundry: {
    SE: 'Är du säker på att du vill skapa en ny tvättstuga?',
    EN: 'Are you sure that you wish to create a new laundry room?'
  },
  deleteLaundryHeader: {
    SE: 'Ta bort tvättstuga',
    EN: 'Remove laundry room'
  },
  deleteLaundry: {
    SE:
      'Är du säker på att du vill ta bort tvättstugan? Alla bokningar kopplade till denna tvättstuga kommer tas bort. Om du vill döpa om tvättstugan och ha kvar bokningarna, var god byt namn istället.',
    EN:
      'Are you sure that you wish to remove the laundry room? All bookings related to this washinghouse will be removed. If you wish to rename the laundry room and keep bookings related to the washinghouse, please change name instead.'
  },
  noLaundryNameHeader: {
    SE: 'Inget namn',
    EN: 'Name missing'
  },
  noLaundryName: {
    SE:
      'En ny tvättstuga behöver ett namn, var god skriv in ett namn och försök igen.',
    EN: 'A new laundry room requires a name, please enter a name and try again.'
  },
  duplicateLaundryNameHeader: {
    SE: 'Namnet finns redan',
    EN: 'Duplicate name'
  },
  duplicateLaundryName: {
    SE:
      'En tvättstugas namn måste vara unikt, var god skriv in ett unikt namn och försök igen.',
    EN:
      'A laundry room name needs to be unique, please enter an unique name and try again.'
  },
  noFieldsChanged: {
    SE: 'Inga ändringar har gjorts',
    EN: 'No changes has been made'
  },
  updateLaundryRulesHeader: {
    SE: 'Uppdatera tvättregler',
    EN: 'Update laundry rules'
  },
  updateLaundryRules: {
    SE: 'Är du säker på att du vill uppdatera tvättreglerna i din förening?',
    EN:
      'Are you sure that you wish to update the laundry rules of your compound?'
  },
  laundryRulesUpdated: {
    SE: 'Tvättreglerna har uppdaterats',
    EN: 'The laundry rules was updated'
  },
  createNewLaundryTimeHeader: {
    SE: 'Skapa en nya tvättid',
    EN: 'Create new laundry time'
  },
  createNewLaundryTime: {
    SE: 'Är du säker på att du vill skapa en ny tvättid?',
    EN: 'Are you sure that you wish to create a new laundry time?'
  },
  laundryTimeCreated: {
    SE: 'Tvättiden har skapats',
    EN: 'The laundry time was created'
  },
  deleteLaundryTimeHeader: {
    SE: 'Ta bort tvättid',
    EN: 'Remove laundry time'
  },
  deleteLaundryTime: {
    SE:
      'Är du säker på att du vill ta bort tvättiden? Alla bokningar kopplade till tiden kommer att tas bort tillsammns med denna handling. Om du endast vill byta tiderna och behålla nuvarande bokningar, var god redigera tiden istället',
    EN:
      'Are you sure that you wish to remove the laundry time? All bookings related to the time will be removed with this action. If you only wish to change the times and keep the bookings, please edit the time instead.'
  },
  timeWasRemoved: {
    SE: 'Tvättiden har tagits bort',
    EN: 'The laundry time was removed'
  },
  laundryUnbooked: {
    SE: 'Tvättiden har avbokats',
    EN: 'The laundry time is unbooked'
  },
  updateLaundryNameHeader: {
    SE: 'Uppdatera namn',
    EN: 'Update name'
  },
  updateLaundryName: {
    SE: 'Är du säker på att du vill uppdatera namnet på tvättstugan?',
    EN: 'Are you sure that you wish to update the name of the laundry room?'
  },
  laundryWasUpdated: {
    SE: 'Tvättstugan har uppdaterats',
    EN: 'The laundry room was updated'
  },
  updateLaundryTimeHeader: {
    SE: 'Uppdatera tvättid',
    EN: 'Update laundry time'
  },
  updateLaundryTime: {
    SE: 'Är du säker på att du vill uppdatera tvättiden?',
    EN: 'Are you sure that you wish to update the laundry time?'
  },
  laundryTimesWasUpdated: {
    SE: 'Tvättiden har uppdaterats',
    EN: 'The laundry time was updated'
  },
  overlappingLaundryTimeHeader: {
    SE: 'Överlappande tider',
    EN: 'Overlapping times'
  },
  overlappingLaundryTime: {
    SE:
      'En annan tid överlappar med din nya tid. Var god välj en tid som inte överlappar med någon annan tid.',
    EN:
      'Another time is overlapping with the new time. Please choose a time which is not overlapping with another time.'
  },
  startTimeBeforeEndTimeHeader: {
    SE: 'Starttiden är efter sluttiden',
    EN: 'Start time before end time'
  },
  startTimeBeforeEndTime: {
    SE:
      'Starttiden får inte vara efter sluttiden. Var god ändra starttid eller sluttid.',
    EN:
      'The start time may not be after the end time. Please change start time or end time.'
  },
  mySettings: {
    SE: 'Mina inställningar',
    EN: 'My settings'
  },
  newPasswordDontMatch: {
    SE: 'Lösenorden matchar inte varandra',
    EN: "The password don't match"
  },
  newPasswordDontMatchText: {
    SE:
      'Lösenordsfälten för ert nya lösenord matchar inte varandra, var god försök igen.',
    EN:
      "The fields for the new password don't match eachother, please try again."
  },
  somethingWentWrong: {
    SE: 'Något gick fel',
    EN: 'Something went wrong'
  },
  passwordUpdateWentWrongText: {
    SE:
      'Var god försök igen eller logga ut och logga in igen. Du kan alltid kontakta din hyresvärd för att återställa lösenordet.',
    EN:
      "Please try again, if it still doesn't work try loging in and out. You can always contact your landlord to have your password reset."
  },
  wrongPasswordHeader: {
    SE: 'Fel lösenord',
    EN: 'Wrong password'
  },
  wrongPassword: {
    SE: 'Du har skrivit in ett felaktigt lösenord. Var god försök igen.',
    EN: 'Wrong password, please try again.'
  },
  whatIsHomePalHeader: {
    SE: 'Vad är HomePal?',
    EN: 'What is HomePal?'
  },
  whatIsHomePal: {
    SE:
      'HomePal är en användarvänlig digital plattform som förenklar vardagen för boende i bostadsrätts- och hyresgästföreningar. HomePal förser i nuläget med ett digitalt tvättbokningssystem.',
    EN:
      'HomePal is a user friendly digital platform that aims to ease the normal day for people living in housing complexes. HomePal currently provides a digital laundry booking system.'
  },
  openAccoutHeader: {
    SE: 'Öppna konto',
    EN: 'Open account'
  },
  tryForFree: {
    SE:
      'Kom enkelt igång med HomePal i din förening med vår 30 dagars testperiod. Testperioden har ingen bidningstid och kräver ej några betalningsuppgigter!',
    EN: 'Get started with HomePal in your compound with our 30 days free trial.'
  },
  tryFree: {
    SE: 'Prova gratis',
    EN: 'Try for free'
  },
  system: {
    SE: 'Systemet',
    EN: 'The system'
  },
  prices: {
    SE: 'Priser',
    EN: 'Prices'
  },
  apartments: {
    SE: 'Lägenheter',
    EN: 'Apartments'
  },
  small: {
    SE: 'Liten',
    EN: 'Small'
  },
  medium: {
    SE: 'Mellan',
    EN: 'Medium'
  },
  large: {
    SE: 'Stor',
    EN: 'Large'
  },
  month: {
    SE: 'månad',
    EN: 'month'
  },
  pricePerApartment: {
    SE: 'Pris per lägenhet',
    EN: 'Price per apartment'
  },
  from: {
    SE: 'Från',
    EN: 'From'
  },
  bindingTime: {
    SE: 'Bindningstid',
    EN: 'Binding time'
  },
  calculateYourPrice: {
    SE: 'Beräkna pris',
    EN: 'Calculate price'
  },
  price: {
    SE: 'Pris',
    EN: 'Price'
  },
  totalPrice: {
    SE: 'Totalt pris',
    EN: 'Final price'
  },
  readMore: {
    SE: 'Läs mer',
    EN: 'Read more'
  },
  trial: {
    SE: 'Kom igång',
    EN: 'Get started'
  },
  yourCommunityName: {
    SE: 'Föreningsnamn',
    EN: 'Compound name'
  },
  communityAlreadyExists: {
    SE: 'Förening finns redan',
    EN: 'Community already exists'
  },
  communityAlreadyExistsText: {
    SE:
      'Föreningen du skrev in finns redan, vänligen korrigera med ett nummer på slutet.',
    EN:
      'The communityname already exists in your town, please try to adjust the name with a number in the end.'
  },
  laundryTypeHelpHeader: {
    SE: 'Välj tvättyp',
    EN: 'Choose laundry type'
  },
  laundryTypeHelpText: {
    SE: 'Välj om din förening ska boka tvättmaskiner eller hela tvättstugor.',
    EN:
      'Choose if you your compound will book laundry machines or entire laundry rooms'
  },
  amountOfLaundriesHeader: {
    SE: 'Antal tvättstugor eller tvättmaskiner',
    EN: 'Number of washing machines or laundry rooms'
  },
  amountOfLaundriesText: {
    SE:
      'Välj hur många tvättstugor eller tvättmaskiner som finns i er förening.',
    EN:
      'Choose how many laundrymachines or laundry rooms you have in your compound'
  },
  yourEmail: {
    SE: 'Din email',
    EN: 'Your email'
  },
  allFieldsRequired: {
    SE: 'Tomma obligatoriska fält',
    EN: 'Empty mandatory fields'
  },
  allFieldsRequiredText: {
    SE: 'Vänligen fyll i alla obligatoriska fält för att gå vidare.',
    EN: 'Please enter all mandatory fields to continue.'
  },
  yourApartmentNumber: {
    SE: 'Ditt lägenhetsnummer',
    EN: 'Your apartment number'
  },
  busy: {
    SE: 'Upptagen',
    EN: 'Occupied'
  },
  bookInAppOrWebpageHeader: {
    SE: 'Boka tvättid i appen eller på hemsidan',
    EN: 'Book laundry time in the app or the webpage'
  },
  translateEverythingHeader: {
    SE: 'Finns på svenska och engelska',
    EN: 'Available in Swedish and English'
  },
  aboutTheAppsHeader: {
    SE: 'Om appen',
    EN: 'About the app'
  },
  adjustableAndUserfrindly: {
    SE: 'Anpassningsbart & Användarvänligt',
    EN: 'Adjustable & User friendly'
  },
  userFriendlyAndAdjustableText: {
    SE:
      'HomePal är utvecklat för att vara användarvänligt för både äldre och yngre. Ni kan enkelt anpassa tvättbokningssystemet efter er förenings tvättvanor och behov.',
    EN:
      'The laundry booking system is designed to be user friendly for both older and younger people. You can easly adjust your laundry booking system after your compounds needs.'
  },
  bookInAppOrWebpage: {
    SE: 'Tvättid går enkelt att boka på mobilen, surfplattan eller datorn.',
    EN: 'Laundry time is easily booked with your phone, tablet or computer.'
  },
  aboutTheApps: {
    SE:
      'HomePals app finns till både Android och iOS. Appen har alla nödvändiga funktioner för att boka tvättid och användare kan enkelt ändra språk till engelska. Appen är självklart helt gratis.',
    EN:
      "HomePal's app exists for both Android and iOS. The app have all neccessary functions to book laundry time and users can easily change language to English. The app is of course free of charge."
  },
  outOfOrder: {
    SE: 'Ur funktion',
    EN: 'Out of order'
  },
  laundryTimes: {
    SE: 'Tvättider',
    EN: 'Laundry times'
  },
  laundryNames: {
    SE: 'Tvättnamn',
    EN: 'Laundry names'
  },
  or: {
    SE: 'eller',
    EN: 'or'
  },
  addAndRemove: {
    SE: 'Lägg till och ta bort',
    EN: 'Add and remove'
  },
  addLaundryTimes: {
    SE: 'Lägg till tvättider',
    EN: 'Add laundry times'
  },
  resetPassword: {
    SE: 'Återställ lösenord',
    EN: 'Reset password'
  },
  adminUsersText: {
    SE:
      'Som administratör för din förening kan du administrera alla föreningens användare.',
    EN:
      "As an admin of your compound you can administrate your compound's users as you see fit."
  },
  addAndRemoveText: {
    SE:
      'Med ett knapptryck kan du, som administratör, ta bort eller lägga till ett lägenhetsnummer.',
    EN: 'With a press of a button an admin may remove or add a new apartment.'
  },
  resetPasswordText: {
    SE:
      'Om en användare skulle glömma sitt lösenord så går det enkelt att återställa till lägenhetsnumret. Användaren kan sedan själv logga in och byta sitt lösenord.',
    EN:
      'If an user would forget his password it can easly be reseted to the apartment number. The user can then log in and change his password.'
  },
  laundryMachines: {
    SE: 'Tvättmaskiner',
    EN: 'Laundrymachines'
  },
  movingOutText: {
    SE:
      'När en användare flyttar ut så kan administratören återställa kontot kopplat till lägenhetsnumret. Detta tar bort alla bokningar kopplat till kontot och sätter lösenordet till lägenhetsnumret. Den nya användaren kan sedan enkelt logga in och byta sitt lösenord.',
    EN:
      'When a user are moving out the admin can reset the account related to the apartment. This will remove all bookings belonging to the account and will set the password to the apartment number. A new resident can then easly log in and change his password.'
  },
  laundryTimesText: {
    SE:
      'Föreningens tvättider går att uppdatera direkt via sidan "Tvättinställningar". Detta gör det enkelt för dig att anpassa tvättiderna efter din förenings behov.',
    EN:
      'The laundry times of the compound can be updated directly via the "Laundry settings" page. This makes it easy for you to customize the laundry times according to your compound\'s needs.'
  },
  laundryNamesText: {
    SE:
      'För att er förening ska kännas så personlig som möjligt så kan ni själva namnge era tvättmaskiner eller tvättstugor.',
    EN:
      'In order for your compound to feel as personal as possible, you can name your laundry machines or laundry rooms yourself.'
  },
  messageSentHeader: {
    SE: 'Tack för ditt meddelande',
    EN: 'Thank you for your message'
  },
  messageSentText: {
    SE: 'Vi har tagit emot ert meddelande och återkommer inom 24 timmar.',
    EN: 'We have received your message and will return to you withing 24 hours.'
  },
  maxBookingsText: {
    SE:
      'Ni besämmer själva hur många tvättmaskiner eller tvättstugor en lägenhet ska kunna boka åt gången, detta går enkelt att uppdatera som administratör.',
    EN:
      'You decide yourselfes how many laundry machines or laundry rooms an apartment should be able to book at a time, this can easily be updated as an admin.'
  },
  bookingRangeText: {
    SE:
      'Begränsa hur många veckor in i framtiden en boende ska kunna ha möjlighet att boka tvättid.',
    EN:
      'Limit how many weeks into the future an accommodation should be able to book laundry time.'
  },
  laundryMachineOrWashouseText: {
    SE:
      'Via "Tvättinställningar" går det att ställa in om ni har tvättmaskin eller tvättstuga.',
    EN:
      'Through the "Laundry settings" page you may enter if you have laundry machines or laundry rooms.'
  },
  outOfOrderDescription: {
    SE:
      'Om en tvättmaskin eller tvättstuga mot all förmodan skulle gå sönder kan administratören sätta denna ur funktion. Detta gör att de boende slipper anpassa sina scheman efter en tvättid som inte kommer att ge något.',
    EN:
      "If a laundry machine or a laundry room against all odds would break, the admin can put this one out of order. This ensures that the residents don't need to adjust their schedules to a broken laundry time."
  },
  translateEverythingText: {
    SE:
      'Både appen och hemsidan kan enkelt ställas in på både svenska eller engelska.',
    EN:
      'Both the app and the website can be easily set in either Swedish or English.'
  },
  userFriendly: {
    SE: 'Användarvänligt',
    EN: 'User friendly'
  },
  userFriendlyText: {
    SE:
      'HomePal är utvecklat för att vara lätt använligt för både äldre och yngre.',
    EN: 'HomePal is developed to be easy to use for younger and older.'
  },
  kevinsRole: {
    SE: 'Medgrundare och utvecklare',
    EN: 'Co founder and developer'
  },
  lovesRole: {
    SE: 'Medgrundare och utvecklare',
    EN: 'Co founder and developer'
  },
  niklasRole: {
    SE: 'Sälj och administration',
    EN: 'Sell- and administrative manager'
  },
  kevinTips: {
    SE:
      'Se bortom färgerna, spara på både miljön och din dyrbara tid genom att fylla varje tvättmaskin även om det kräver att rött och blått blandas.',
    EN:
      'See beyond colors, save both your precious time and the environment by filling every laundry machine even if you have to mix red and blue.'
  },
  loveTips: {
    SE:
      'Häng upp skjortan på en galge direkt efter tvätten. Då slipper du stryka och får ändå en slät skjorta.',
    EN:
      'Hang the shirt on a hanger immediately after washing. Then you do not iron and still have a smooth shirt.'
  },
  niklasTips: {
    SE:
      'Våga utmana gradantalet! Faktum är att tvätta i 40 grader förbrukar endast hälften så mycket energi som om du tvättar i 60 grader.',
    EN:
      'Dare to challenge the degree! In fact, washing at 40 degrees consumes only half as much energy as if you wash at 60 degrees.'
  },
  kevinExperience: {
    SE: 'Mjukvaruutvecklare på Axis Communications & IT-konsult på Lunicore',
    EN: 'Software developer at Axis Communications & IT-consultant at Lunicore'
  },
  loveExperience: {
    SE: 'IT-konsult på Lunicore',
    EN: 'IT-consultant at Lunicore'
  },
  niklasExperience: {
    SE: 'Skadereglerare på Folksam & Regionchef Helsingborg på Lunicore',
    EN: 'Damage control at Folksam & Regional manager Helsingborg at Lunicore'
  },
  kevinsEducation: {
    SE:
      'Pågående utbildning till Civilingenjör i Datateknik, Lunds Tekniska Högskola',
    EN: 'Ongoing studies in Computer Science & Engineering, Lunds University'
  },
  lovesEducation: {
    SE:
      'Pågående utbildning till Civilingenjör i Datateknik, Lunds Tekniska Högskola',
    EN: 'Ongoing studies in Computer Science & Engineering, Lunds University'
  },
  niklasEducation: {
    SE: 'Service Management, Lunds Universitet',
    EN: 'Service Management, Lunds University'
  },
  bestLaundryTips: {
    SE: 'Bästa tvättips',
    EN: 'Best laundry tips'
  },
  experience: {
    SE: 'Erfarenheter',
    EN: 'Experiences'
  },
  education: {
    SE: 'Utbildning',
    EN: 'Education'
  },
  edit: {
    SE: 'Ändra',
    EN: 'Edit'
  },
  putOutOfOrder: {
    SE: 'Sätt ur funktion',
    EN: 'Put out of order'
  },
  putFunctioning: {
    SE: 'Sätt fungerande',
    EN: 'Put functioning'
  },
  delete: {
    SE: 'Ta bort',
    EN: 'Delete'
  },
  showAsCalendar: {
    SE: 'Visa som kalender',
    EN: 'Show as calendar'
  },
  showAsScheme: {
    SE: 'Visa som schema',
    EN: 'Show as schedule'
  },
  startHour: {
    SE: 'Starttimme',
    EN: 'Start hour'
  },
  endHour: {
    SE: 'Sluttimme',
    EN: 'End hour'
  },
  startMinute: {
    SE: 'Startminut',
    EN: 'Start minute'
  },
  endMinute: {
    SE: 'Slutminut',
    EN: 'End minute'
  },
  cityHelpHeader: {
    SE: 'Välj din stad',
    EN: 'Select your city'
  },
  city: {
    SE: 'Stad',
    EN: 'City'
  },
  lastName: {
    SE: 'Efternamn',
    EN: 'Surname'
  },
  cityHelp: {
    SE: 'Välj den stad som du bor i.',
    EN: 'Select the city you live in.'
  },
  compoundHelpHeader: {
    SE: 'Välj din förening',
    EN: 'Select your compound'
  },
  compoundHelp: {
    SE:
      'Välj din förening. Var god dubbelkolla så att du har valt rätt stad om du inte hittar din förening.',
    EN:
      'Select your compound. Please dubble check that you have selected the correct city if you can not find your compound.'
  },
  emailHelpHeader: {
    SE: 'Skriv in din emailadress',
    EN: 'Enter your email address'
  },
  emailHelp: {
    SE: 'Din emailadress används som användarnamn.',
    EN: 'Your email address is used as username.'
  },
  passwordHelpHeader: {
    SE: 'Skriv in ditt lösenord',
    EN: 'Enter your password'
  },
  passwordHelp: {
    SE:
      'Skriv in ditt lösenord. Om du har glömt ditt lösenord, var god kontakta din förenings styrelse.',
    EN:
      'Enter your password. If you have forgotten your password, please contact your compound board.'
  },
  noPasswordHeader: {
    SE: 'Lösenord saknas',
    EN: 'Password missing'
  },
  contactPerson: {
    SE: 'Kontaktperson',
    EN: 'Contact person'
  },
  invoiceAddress: {
    SE: 'Faktureringsadress',
    EN: 'Invoice address'
  },
  address: {
    SE: 'Adress',
    EN: 'Address'
  },
  zipCode: {
    SE: 'Postnummer',
    EN: 'Zip code'
  },
  helpPriceApartmentHeader: {
    SE: 'Antal lägenheter',
    EN: 'Amount of apartments'
  },
  noPasswordText: {
    SE: 'Inget lösenord har angetts, var god försök igen.',
    EN: 'No password has been entered, please try again.'
  },
  helpPriceApartmentText: {
    SE: 'Välj hur många lägenheter ni har i era förening.',
    EN: 'Select how many apartments you have in your compound'
  },
  oldPasswordHeader: {
    SE: 'Var god skriv i ditt gamla lösenord',
    EN: 'Please enter your old password'
  },
  nobody: {
    SE: 'Ej bokad',
    EN: 'Not booked'
  },
  none: {
    SE: 'Ingen',
    EN: 'None'
  },
  update: {
    SE: 'Uppdatera',
    EN: 'Update'
  },
  noEmailHeader: {
    SE: 'Email saknas',
    EN: 'Email missing'
  },
  noEmailText: {
    SE: 'Ingen email har angetts, var god försök igen.',
    EN: 'No email has been entered, please try again.'
  },
  whyEmailHeader: {
    SE: 'Lägg till din email',
    EN: 'Add your email'
  },
  whyEmailText: {
    SE:
      'Om du kopplar din email till ditt konto så blir det enklare att återfå det om du glömmer ditt lösenord.',
    EN:
      'If you connect your email to your account it will become easier to reclaim it if you forget your password.'
  },
  infoAboutApartmentHeader: {
    SE: 'Ditt lägenhetsnummer',
    EN: 'Your apartment number'
  },
  infoAboutApartmentText: {
    SE:
      'Ditt lägenhetsnummer används som användarnamn när du loggar in. Kontakta din styrelse för att byta lägenhetsnummer.',
    EN:
      'Your apartment number is used as your username. Contact your board to change the apartment number.'
  },
  infoAboutCommunityHeader: { SE: 'Föreningens namn', EN: "Compound's name" },
  infoAboutCommunityText: {
    SE:
      'Detta är din förenings namn. Om du skulle upptäcka något fel med förenings namnet, var god kontakta din styrelse.',
    EN:
      "This is your compound's name. If you discover something wrong with the name, please contact your board."
  },
  weContantYou: { SE: 'Vi kontaktar er', EN: 'We contact you' },
  appIncluded: {
    SE:
      'Vår app finns på App Store och Google Play och ingår i samtliga erbjudanden.',
    EN:
      'Our app is on App Store and Google Play and is included in all price offers.'
  },
  sek: {
    SE: 'kr',
    EN: 'SEK'
  },
  back: {
    SE: 'Tillbaka',
    EN: 'Back'
  },
  done: {
    SE: 'Klar',
    EN: 'Done'
  },
  next: {
    SE: 'Nästa',
    EN: 'Next'
  },
  remove: {
    SE: 'Ta bort',
    EN: 'Remove'
  },
  almostAHomePal: {
    SE: 'Du är bara ett steg från att bli en HomePal!',
    EN: 'You are only one step away from becoming a HomePal!'
  },
  verifyMail1: {
    SE: 'Ett mail har skickats till ',
    EN: 'An email has been send to '
  },
  verifyMail2: {
    SE:
      '. Klicka på länken i mailet för att verifiera din mailadress och aktivera kontot.',
    EN:
      '. Click the link in the mail to verify your email address and activate the account.'
  },
  accessToApp1: {
    SE: 'Alla i föreningen får tillgång till ',
    EN: 'The whole compound gets access to '
  },
  accessToApp2: {
    SE: 'HomePals app ',
    EN: "HomePal's app "
  },
  accessToApp3: {
    SE: 'som finns på både App Store och Google Play.',
    EN: 'that exists on both App Store and Google Play.'
  },
  numberOfApartments: {
    SE: 'Antal lägenheter',
    EN: 'Number of apartments'
  },
  countryCode: {
    SE: 'Landskod',
    EN: 'Country code'
  },
  notValidPhoneNumberHeader: {
    SE: 'Ej giltligt telefonnummer',
    EN: 'Not valid phone number'
  },
  notValidPhoneNumberText: {
    SE: 'Var god skriv in ett riktigt telefonnummer.',
    EN: 'Please enter a real phone number.'
  },
  notValidZipCodeHeader: {
    SE: 'Ej giltligt postnummer',
    EN: 'Not valid zip code'
  },
  notValidZipCodeText: {
    SE: 'Var god skriv in ett riktigt postnummer.',
    EN: 'Please enter a real zip code.'
  },
  toLogin: {
    SE: 'Till login',
    EN: 'To sign in'
  },
  createYourAccountHeader: {
    SE: 'Skapa din inloggning',
    EN: 'Create your account'
  },
  createYourAccountText: {
    SE:
      'Här skapar du dina inloggningsuppgifter. När detta är gjort kan du sedan lägga till fler användare till din förening.',
    EN:
      'Here you will create your credentials. When this is done you may add more users to your compound.'
  },
  becomeAHomepal: {
    SE: 'Bli en Homepal',
    EN: 'Becoma a Homepal'
  },
  invalidTokenText1: {
    SE: 'Din token är inte giltig. Kontakta ',
    EN: 'Your token is not valid. Contact '
  },
  invalidTokenText2: {
    SE: ' om detta är felaktigt.',
    EN: ' if this is wrong.'
  },
  somethingWentWrongPleaseReload: {
    SE: 'Något gick fel med valideringen av din token. Var god ladda om sidan.',
    EN:
      'Something went wrong with the validation of your token. Please reload this page.'
  },
  accountHasBeenActivated1: {
    SE: 'Kontot har redan aktiverats. Kontakta ',
    EN: 'The account has already been updated. Contact '
  },
  accountHasBeenActivated2: {
    SE: ' om detta är felaktigt.',
    EN: ' if this is wrong.'
  },
  emailTokenExpiredAlertHeader: {
    SE: 'Sessionen har löpt ut',
    EN: 'The session has expired'
  },
  emailTokenExpiredAlertText: {
    SE: 'Sessionen har löpt ut, var god uppdatera sidan.',
    EN: 'The session has expired, please update the page.'
  },
  paymentInformation: {
    SE: 'Information angående betalning',
    EN: 'Payment information'
  },
  freePeriodExpires: {
    SE: 'Gratis period t.o.m.',
    EN: 'Free period until'
  },
  addCampaignCode: {
    SE: 'Lägg till kampanjkod',
    EN: 'Add campaign code'
  },
  doYouHaveACampagnCode: {
    SE: 'Har du en kampanjkod?',
    EN: 'Do you have a campaign code?'
  },
  addCampaignCodeHeader: {
    SE: 'Skriv in din kampanjkod',
    EN: 'Enter your campaign code'
  },
  campaignCode: {
    SE: 'Kampanjkod',
    EN: 'Campaign code'
  },
  invalidCampaignCodeHeader: {
    SE: 'Kampanjkoden är ej giltlig',
    EN: 'The campaign code is invalid'
  },
  invalidCampaignCodeText: {
    SE: 'Kampanjkoden som skrevs in är inte giltlig, var god försök igen.',
    EN: 'The entered campaign code is not valid, please try again.'
  },
  ourVisionHeader: {
    SE: 'Vår vision',
    EN: 'Our vision'
  },
  ourVisionText: {
    SE:
      'Att underlätta vardagen för bostadsrättsföreningar med en användarvänlig digital plattform. Plattformen effektiviserar det administrativa arbetet och skapar gemenskap i föreningen.',
    EN:
      'To ease everyday work for housing complexes with an easy to use digital platform. The platform aims to make the administrative work more efficient and create solidarity within the compound.'
  },
  ourHistoryHeader: {
    SE: 'Vår historia',
    EN: 'Our history'
  },
  ourHistoryText1: {
    SE:
      'HomePal är tre studenter vid Lunds Universitet tillsammans med alla våra användare. Med pågående utbildningar till Civilingenjör i Datateknik har vi koll på de senaste teknikerna inom IT. Vi vill nyttja denna kompetens i kombination med nära kundkontakt för att ta fram världens bästa och mest prisvärda digitala plattform för bostadsrättsföreningar.',
    EN:
      "HomePal is three students at Lunds University and all our customers. With ongoing education in Computer Science and Engineering we know the latest techniques in IT. We wish to use this competence in combination with close customer contact to create the world's best digital platform for housing complexes."
  },
  ourHistoryText2: {
    SE:
      'HomePal kom till då vi såg ett stort glapp mellan hur många människor bokar tvättid och den teknik som finns idag.',
    EN:
      'HomePal was created since we saw a big gap between how many people are booking laundry times and the latest IT technique.'
  },
  ourHistoryText3: {
    SE: 'Fokusera på det som spelar roll.',
    EN: 'Focus on what matters.'
  },
  ourTeam: {
    SE: 'Vårt team',
    EN: 'Our team'
  },
  generalAboutTheSystem: {
    SE: 'Allmänt om systemet',
    EN: 'General about the system'
  },
  sekPerMonth: {
    SE: 'kr/månad inkl moms',
    EN: 'SEK/month including VAT'
  },
  termsOfUse: {
    SE: 'Användarvillkor',
    EN: 'Terms of use'
  },
  termsOfUseGeneralHeader: {
    SE: '1. Allmänt',
    EN: 'Coming soon...'
  },
  termsOfUseGeneral: {
    SE:
      'HomePal är en digital plattform som ger bostadsrättsinnehavare (Användare) möjlighet att boka tvättid via app och hemsida (Tjänsten). För att en Användare ska kunna få tillgång till Tjänsten krävs att bostadsrättsföreningen (Kunden) har anslutit föreningen till HomePal genom att acceptera villkoren nedan.',
    EN: 'Coming soon...'
  },
  termsOfUsePayment: {
    SE:
      'Köp av Tjänsten sker i abonnemangsform. Abonnemang tecknas för en period om 1 månad (Abonnemangsperiod). Abonnemanget förnyas automatiskt genom att Abonnemangsperioden förlängs med 1 månad om inte Kunden har sagt upp abonnemanget dessförinnan.',
    EN: 'Coming soon...'
  },
  termsOfUsePaymentHeader: {
    SE: '2. Betalningsvillkor',
    EN: 'Coming soon...'
  },
  termsOfUsePayment1: {
    SE:
      'Köp av Tjänsten sker i abonnemangsform. Abonnemang tecknas för en period om 1 månad (Abonnemangsperiod). Abonnemanget förnyas automatiskt genom att Abonnemangsperioden förlängs med 1 månad om inte Kunden har sagt upp abonnemanget dessförinnan.',
    EN: 'Coming soon...'
  },
  termsOfUsePayment2: {
    SE:
      'Abonnemang tecknas av behörig företrädare för Kunden. Blankett härför finns på HomePals hemsida. Betalning av abonnemangsavgiften sker kvartalsvis i efterskott, eller för en kortare period om detta föranleds av Kundens uppsägning. Betalning ska erläggas senast den 28:e i månaden efter kvartalet eller efter det att uppsägning skett. Betalning sker genom att Kunden sätter in pengarna på HomePals konto.',
    EN: 'Coming soon...'
  },
  termsOfUsePayment3: {
    SE:
      'Om Kunden inte har erlagt betalning senast på förfallodagen har HomePal rätt till ersättning för kostnader för betalningspåminnelser och inkasso samt till dröjsmålsränta enligt lag.',
    EN: 'Coming soon...'
  },
  termsOfUseTerminationHeader: {
    SE: '3. Uppsägning av abonnemang',
    EN: 'Coming soon...'
  },
  termsOfUseTermination1: {
    SE:
      'Kunden har rätt att säga upp abonnemanget när som helst genom att kontakta HomePal (kontaktuppgifter finns på hemsidan). Uppsägning av abonnemanget kan ske via HomePals e-post.',
    EN: 'Coming soon...'
  },
  termsOfUseTermination2: {
    SE:
      'HomePal har rätt att säga upp avtalet helt eller delvis med tre månaders uppsägningstid. Uppsägning kan ske genom e-post till Kundens uppgivna e-postadress.',
    EN: 'Coming soon...'
  },
  termsOfUseHandlingOfPersonalDataHeader: {
    SE: '4. Behandling av personuppgifter',
    EN: 'Coming soon...'
  },
  termsOfUseHandlingOfPersonalData: {
    SE:
      'Homepal behandlar och lagrar kontaktuppgifter som namn, e-postadresser och telefonnummer till kontaktpersoner för Kunden samt adress till Kunden. Uppgifterna används för att kunna kontakta och fakturera Kunden.',
    EN: 'Coming soon...'
  },
  termsOfUseChangeOfTermsHeader: {
    SE: '5. Ändring av villkoren',
    EN: 'Coming soon...'
  },
  termsOfUseChangeOfTerms1: {
    SE:
      'HomePal förbehåller sig rätten att när som helst ändra eller göra tillägg till dessa villkor. Meddelande om ändring i villkoren lämnas via e-postmeddelande innan ikraftträdandet. Om Kunden inte accepterar meddelad ändring av villkoren, har denne rätt att frånträda abonnemanget.',
    EN: 'Coming soon...'
  },
  termsOfUseChangeOfTerms2: {
    SE:
      'Avgiftsändringar sker genom att ändringen införs i prislistan. Avgiftshöjning som påverkar Kunden får dock ske tidigast tre månader efter det att Kunden meddelats om höjningen via e-post.',
    EN: 'Coming soon...'
  },
  termsOfUseErrorHeader: {
    SE: '6. HomePals ansvar för fel i Tjänsten',
    EN: 'Coming soon...'
  },
  termsOfUseError: {
    SE:
      'Om Tjänsten skulle ligga nere mer än 24 timmar efter det att kunden har anmält felet till HomePal så erhåller Kunden ett prisavdrag som motsvarar en månads avgift. Om avbrottet beror på omständigheter som HomePal inte råder över (t ex elavbrott eller störningar i Internet) erhåller Kunden dock inte något prisavdrag.',
    EN: 'Coming soon...'
  },
  haveReadTermsOfUse: {
    SE:
      'Jag har läst och förstår detta avtal och jag accepterar och samtycker till samtliga villkor.',
    EN:
      'I have read and understand this agreemnet, and I accept and agree to all of its terms and conditions.'
  },
  acceptTermsOfUseToContinueHeader: {
    SE: 'Var god acceptera användarvillkoren',
    EN: 'Please accept the terms of use'
  },
  acceptTermsOfUseToContinueText: {
    SE:
      'Du måste acceptera användarvillkoren för att fortsätta. Om det finns några oklarheter, var god kontakta info@homepal.se.',
    EN:
      'You need to accept the terms of use to continue. If thera are any uncertainties, please contact info@homepal.se.'
  },
  termsOfUseInEnglish: {
    SE:
      'Användarvillkoren måste läsas och förstås samt accepteras och samtyckas till på svenska.',
    EN:
      'The terms of use must be read and understood, accepted and agreed to in Swedish.'
  },
  startRegistration: {
    SE: 'Påbörja registrering',
    EN: 'Start registration'
  },
  setupLaundrySettings: {
    SE:
      'Nu återstår bara att ställa in era tvättinställnigar! Ni kan alltid ändra dem senare.',
    EN:
      'Now you only need to set your laundry settings! You can allways edit them later.'
  },
  laundryMachineOrWashhouseQuestion: {
    SE: 'Då kör vi! Ska en boka tvättmaskin eller tvättstuga?',
    EN: "Let's go! Should one book laundry machine or washhouse?"
  },
  howMany: {
    SE: 'Hur många',
    EN: 'How many'
  },
  doYouHave: {
    SE: 'Har ni',
    EN: 'Do you have'
  },
  soonThere: {
    SE: 'Nu är vi snart hemma',
    EN: 'Almost there'
  },
  whenIsYourFirstLaundryTime: {
    SE: 'När är er första tvättid',
    EN: 'When is your first laundry time'
  },
  howManyLaundryTimes: {
    SE: 'Hur många tvättider har ni',
    EN: 'How many laundry times do you have'
  },
  otherLaundryTimes: {
    SE:
      'Har ni tvättider som är olika långa? Det är ingen fara, ni kan ställa in detta sernare i fliken "Tvättinställningar".',
    EN:
      'Do you have laundry times which got different length? No worries, you can set this up later in "Laundry settings".'
  },
  howLongIsEachLaundryTime: {
    SE: 'Hur lång är varje tvättid',
    EN: 'How long is every laundry time'
  },
  hours: {
    SE: 'Timmar',
    EN: 'Hours'
  },
  minutes: {
    SE: 'Minuter',
    EN: 'Minutes'
  },
  okeyLastPage: {
    SE:
      'Okej, sista sidan! Hur många tider ska en användare kunna boka åt gången?',
    EN:
      'Okey, last page! How many times should an user be able to book at a time?'
  },
  howLongIntoTheFuture: {
    SE: 'Hur många veckor framåt ska en användare kunna boka tvättider?',
    EN:
      'How many weeks into the future should a user be able to book laundry times?'
  },
  allSetLetsBook: {
    SE: 'Klart, nu är det bara att börja boka!',
    EN: 'All set, now you can just start booking!'
  },
  youCanChangeYourLaundrySettingsLater: {
    SE:
      'Om något har blivit fel eller om ni vill ändra era tvättinställnigar så kan du som administratör enkelt ändra dessa under fliken "Tvättinställningar"',
    EN:
      'If you something went wrong or if you wish to change your laundry settings you can easly do so in "Laundry settings"'
  },
  startBooking: {
    SE: 'Börja boka',
    EN: 'Start booking'
  },
  setupLaundry: {
    SE: 'Ställ in tvättinställnigar',
    EN: 'Set laundry settings'
  },
  addUser: {
    SE: 'Lägg till användare',
    EN: 'Add user'
  },
  userJoinCommunity: {
    SE: 'Hur går en användare med i er förening?',
    EN: 'How can a new user join your housing association?'
  },
  here: {
    SE: 'här',
    EN: 'here'
  },
  followFourSteps1: {
    SE:
      'Här nedan följer 4 enkla steg för att en ny användare ska kunna gå med i er förening. Vi rekommenderar att ni skriver ut manualen som kan laddas ner ',
    EN:
      'Here follows 4 simple steps that a new user should follow to join your housing association. We recommend that you prin the manual which may be downloaded '
  },
  followFourSteps2: {
    SE: ' och delar ut den till era boende.',
    EN: ' and deliver them to your residents.'
  },
  joinStep1: {
    SE: 'En ny använare går in på ',
    EN: 'A new user navigates to '
  },
  joinStep2_1: {
    SE: 'Användaren klickar på ',
    EN: 'The user clicks '
  },
  joinStep2_2: {
    SE: ' högst upp i högra hörnet och sedan på ',
    EN: ' in the right top corner and then '
  },
  joinStep3: {
    SE: 'Användaren fyller sedan i er förenings privata kod som är ',
    EN: "The user then enters your housing association's private code which is "
  },
  joinStep4_1: {
    SE: 'Användaren fyller i resternade uppgifter och klickar på ',
    EN: 'The user enters the rest of the information and click on '
  },
  joinStep4_2: {
    SE: '. Nu är användaren inloggad och kan börja boka tvättid!',
    EN: '. The user is now ready to book laundry times!'
  },
  firstTimeInfoUserJoinCommunity1: {
    SE:
      'Ett mail har skickats till dig med en manual för hur era boende går med i er förening. Vi rekommenderar att ni skriver ut denna och lägger den i de boendes brevlådor.',
    EN:
      'A mail has been send to you with a guide of how your residents joins your housing association. We recommend that you print the guide and put it in the letter boxes.'
  },
  firstTimeInfoUserJoinCommunity2: {
    SE:
      'Samma information som finns i mailet finns under fliken "Lägg till användare". Här kan ni även ladda ner manualen.',
    EN:
      'The same information can be found under the tab "Add user". Here you also may download the guide.'
  },
  navigateToAddUser: {
    SE: 'Till "Lägg till användare"',
    EN: 'To "New user"'
  },
  addLaterStartBooking: {
    SE: 'Börja boka direkt',
    EN: 'Start booking'
  },
  easyToUse: {
    SE: 'Lätt att använda',
    EN: 'Easy to use'
  },
  bookWithAppOrWeb: {
    SE: 'Boka med app eller på webben',
    EN: 'Book with the app or on the web'
  },
  bookWithAppOrWebText: {
    SE: 'Boka enkelt tvättid med din telefon eller dator.',
    EN: 'Book laundry time with your phone or computer.'
  },
  selectBetweenTwoLangauges: {
    SE: 'Välj mellan 2 språk',
    EN: 'Select between 2 languages'
  },
  bothAppAndWebInEnglish: {
    SE: 'Både app och hemsida går att översätta mellan engelska och svenska.',
    EN: 'Both app and webpage can be translated between English and Swedish.'
  },
  getStartedWithThreeSteps: {
    SE: 'Kom igång på 3 minuter, med 3 enkla steg',
    EN: 'Get started in 3 minutes, with 3 simple steps'
  },
  userInFocus: {
    SE: 'Användarna i fokus, ge feedback direkt i appen',
    EN: 'The users are in focus, give feedback in the app'
  },
  setupYourLaundrySettings: {
    SE: 'Ställ in era tvättinställningar',
    EN: 'Setup your laundry settings'
  },
  setupYourLaundrySettingsText: {
    SE:
      'Första gången ni loggar in så ställer vi några frågor för att kunna ställa in tvättbokningssystemet helt enligt era preferenser.',
    EN:
      'The first time you sign in we ask some questions so that we can set up your laundry booking system to fit your preferences.'
  },
  giveOurGuide: {
    SE: 'Ge ut vår enkla guide till era boende',
    EN: 'Give our guide to your residents'
  },
  giveOurGuideText: {
    SE:
      'I inloggat läge kan ni ladda ner vår guide som innehåller information till de boende om hur de ansluter till ert nya digitala tvättbokningssystem.',
    EN:
      'When you have signed in you can download our guide containing information to the residents about how they connect to your new digital laundry booking system.'
  },
  getStarted: {
    SE: 'Kom igång',
    EN: 'Get started'
  },
  reportError: {
    SE: 'Rapportera fel',
    EN: 'Report error'
  },
  errorReport: {
    SE: 'Felrapportering',
    EN: 'Error report'
  },
  myErrorReports: {
    SE: 'Mina felrapporteringar',
    EN: 'My error reports'
  },
  reportAnError: {
    SE: 'Rapportera ett fel',
    EN: 'Report an error'
  },
  alertMissingSubjectHeader: {
    SE: 'Ämne saknas',
    EN: 'Subject is missing'
  },
  alertMissingSubject: {
    SE: 'Var god skriv in ett ämne för att fortsätta.',
    EN: 'Please enter a subject to proceed.'
  },
  alertMissingMessageHeader: {
    SE: 'Meddelande saknas',
    EN: 'Subject is missing'
  },
  alertMissingMessage: {
    SE: 'Var god skriv in ett meddelande för att fortsätta.',
    EN: 'Please enter a message to proceed.'
  },
  alertMissingLocationHeader: {
    SE: 'Plats saknas',
    EN: 'Subject is missing'
  },
  alertMissingLocation: {
    SE: 'Var god fyll i vart felet är för att fortsätta.',
    EN: 'Please enter a location of the error to proceed.'
  },
  alertSolveErrorReportHeader: {
    SE: 'Markera som löst',
    EN: 'Mark as solved'
  },
  alertSolveErrorReport: {
    SE: 'Vill du markera felrapporteringen som löst?',
    EN: 'Are you sure that you wish to make the error report as solved?'
  },
  alertArchiveErrorReportHeader: {
    SE: 'Arkivera',
    EN: 'Archive'
  },
  alertArchiveErrorReport: {
    SE: 'Är du säker på att du vill arkivera felrapporteringen?',
    EN: 'Are you sure that you wish to make archive the error report?'
  },
  openErrorReports: {
    SE: 'Öppna felrapporteringar',
    EN: 'Open error reports'
  },
  solvedErrorReports: {
    SE: 'Lösta felrapporteringar',
    EN: 'Solved error reports'
  },
  closedErrorReports: {
    SE: 'Arkiverade felrapporteringar',
    EN: 'Archived error reports'
  },
  alertOpenErrorReportHeader: {
    SE: 'Öppna',
    EN: 'Open'
  },
  alertOpenErrorReport: {
    SE: 'Är du säker på att du vill öppna felrapporteringen?',
    EN: 'Are you sure that you wish to make open the error report?'
  },
  reportedErrors: {
    SE: 'Inskickade fel',
    EN: 'Reported errors'
  },
  alertNoPriviligeErrorReportHeader: {
    SE: 'Felrapportering har ej aktiverats',
    EN: 'Error reporting has not been activated'
  },
  alertNoPriviligeErrorReportAdmin: {
    SE:
      'Felrapporteringssystemet har inte aktiverats av er förening.\n\nVill du ansluta din förening till HomePals nya felrapporteringssystem eller vill du har mer information?\n\nMaila då info@homepal.se så sätter vi upp det till er, helt utan extra kostnad!',
    EN:
      'The error report system has not yet been activated.\n\nDo you wish to connect your housing association to HomePals new error reporting system or do you want more information?\n\nThen send an email to info@homepal.com and we will set it up for your, of course without any fees!'
  },
  alertNoPriviligeErrorReport: {
    SE:
      'Felrapporteringssystemet har inte aktiverats av er förening. Detta kan endast göras av en administratör för er förening.',
    EN:
      'The error report system has not yet been activated. This may only be done by an administrator for your housing association.'
  },
  testSystem: {
    SE: 'Prova på',
    EN: 'Try now'
  },
  administrateCommunityInformation: {
    SE: 'Administrera föreningsinformation',
    EN: 'Administrate association informaion'
  },
  alertNotValidUrlHeader: {
    SE: 'Ej giltlig hemsida',
    EN: 'Not valid webpage'
  },
  alertNotValidUrl: {
    SE: 'Var god skriv in en riktig hemsida.',
    EN: 'Please enter a real webpage.'
  },
  deleteCommunityInformationHeader: {
    SE: 'Ta bort föreningsinformation',
    EN: 'Remove association information'
  },
  deleteCommunityInformation: {
    SE:
      'Är du säker på att du vill ta bort den valda föreningsinformationen? Detta kan inte göras ogjort.',
    EN:
      'Are you sure you wish to remove the chosen association information? This can not be undone.'
  },
  errorReportEmailSendHeader: {
    SE: 'Felrapport skickad',
    EN: 'Error report send'
  },
  errorReportEmailSend: {
    SE: 'Din felrapportering har skickats till din vaktmästare!',
    EN: 'Your error report has been send to your janitor!'
  },
  sessionExpiredHeader: {
    SE: 'Sessionen har löpt ut',
    EN: 'The session has expired'
  },
  sessionExpired: {
    SE: 'Sessionen har löpt ut, var god logga in igen.',
    EN: 'The session has expired, please sign in again.'
  }
}



// WEBPACK FOOTER //
// ./src/assets/strings/Strings.js